import React from "react";
import { useTranslation } from "react-i18next";

/**
 * 群聊成员面板
 * 在线状态、角色标签，当前用户高亮
 * 保存存档按钮置于成员和AI角色列表最下方
 */
const getAgentDescription = (agent) =>
  agent.roleDesc ||
  agent.description ||
  agent.desc ||
  agent.promptSummary ||
  "负责结合当前阶段提供工程分析、方案建议和风险提醒。";

const MemberPanel = ({
  members,
  agents,
  myUserId,
  status,
  onSaveArchive,
  roomId,
  onMention,
  activeAgentIds = [],
  activeStreamingAgentIds = [],
}) => {
  const { t } = useTranslation();
  const activeAgentSet = new Set(activeAgentIds);
  const streamingAgentSet = new Set(activeStreamingAgentIds);

  // 在线优先排序，离线成员置后
  const sortedMembers = [...members].sort((a, b) => {
    if (a.isOnline && !b.isOnline) return -1;
    if (!a.isOnline && b.isOnline) return 1;
    return 0;
  });
  const sortedAgents = [...agents].sort((a, b) => {
    const getPriority = (agent) => {
      if (streamingAgentSet.has(agent.agentId)) return 0;
      if (activeAgentSet.has(agent.agentId)) return 1;
      return 2;
    };
    return getPriority(a) - getPriority(b);
  });

  const showSaveBtn = (status === "active" || status === "completed") && roomId && onSaveArchive;

  return (
    <div className="groupchat-member-panel">
      <h3>{t("groupchat.members")}</h3>
      <div className="member-list">
        {sortedMembers.map((m) => (
          <div
            key={m.userId}
            className={`member-card ${m.isOnline ? "online" : "offline"} ${myUserId && m.userId === myUserId ? "member-card-me" : ""} ${onMention ? "mentionable" : ""}`}
            onDoubleClick={() => onMention?.(m.userId, m.username)}
            title={onMention ? "双击 @ 提及" : undefined}
          >
            <span className="member-status">{m.isOnline ? "●" : "○"}</span>
            <div className="member-info">
              <span className="member-name">{m.username}</span>
              {m.roleName && <span className="member-role">{m.roleName}</span>}
            </div>
          </div>
        ))}
      </div>
      <h3>{t("groupchat.agents")}</h3>
      <div className="agent-list">
        {sortedAgents.map((a) => {
          const isActiveAgent = activeAgentSet.has(a.agentId);
          const isReplying = streamingAgentSet.has(a.agentId);
          return (
            <div
              key={a.agentId}
              className={`agent-card ${isActiveAgent ? "active-phase-agent" : "inactive-phase-agent"} ${isReplying ? "replying-agent" : ""} ${onMention ? "mentionable" : ""}`}
              onDoubleClick={() => onMention?.(a.agentId, a.displayName)}
              title={onMention ? "双击 @ 提及" : undefined}
            >
              <span className="agent-icon" aria-hidden="true">🤖</span>
              <div className="agent-info">
                <span className="agent-name">{a.displayName}</span>
                <span className="agent-desc">{getAgentDescription(a)}</span>
                <span className="agent-state-row">
                  <span className={`agent-state-dot ${isReplying ? "replying" : isActiveAgent ? "active" : ""}`} />
                  <span className="agent-state-text">
                    {isReplying ? "正在回复" : isActiveAgent ? "当前阶段参与" : "待命"}
                  </span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {showSaveBtn && (
        <button
          className="groupchat-save-archive-btn"
          onClick={onSaveArchive}
          title={t("groupchat.save_archive")}
        >
          {t("groupchat.save_archive")}
        </button>
      )}
    </div>
  );
};

export default MemberPanel;
